import { Component, OnInit, ChangeDetectorRef, AfterViewChecked } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { iif } from 'rxjs';
import { UpToDateBuildService } from './version-check/up-to-date.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})
export class AppComponent implements OnInit, AfterViewChecked {
  public title = 'BPMOffice';
  public hideHeaderSideNavFooter: Boolean = false
  public expectedComponents
  public expectedComponentsType: any = { full: false, medium: false, low: false }


  constructor(private changeDetector: ChangeDetectorRef, private route: ActivatedRoute, private router: Router, UpToDateBuildService: UpToDateBuildService) {

  }
  async ngOnInit() {
    // await this.hideAllHeaderSideNavFooter()

  }

  async hideAllHeaderSideNavFooter() {

    // this.router.events.subscribe(event => {
    //   if (event instanceof NavigationEnd) {
    //     this.expectedComponents = this.route.root.firstChild.snapshot.data['expectedComponents']
    //     console.log(this.expectedComponents)
    //     if (this.expectedComponents == "FULL") {
    //       this.expectedComponentsType.full = true
    //       this.expectedComponentsType.medium = false
    //       this.expectedComponentsType.low = false
    //     } else if (this.expectedComponents == "MEDIUM") {
    //       this.expectedComponentsType.full = false
    //       this.expectedComponentsType.medium = true
    //       this.expectedComponentsType.low = false
    //     } else if (this.expectedComponents == "LOW") {
    //       this.expectedComponentsType.full = false
    //       this.expectedComponentsType.medium = false
    //       this.expectedComponentsType.low = true
    //     }
    //     console.log(this.expectedComponentsType)
    //   }
    // });


    let path = window.location.href.split("#")
    if (path[1] == "/TestClientContact" || path[1] == "/POC" || path[1] == "/login") {
      this.hideHeaderSideNavFooter = true
    } else {
      this.hideHeaderSideNavFooter = false
    }
  }
  async ngAfterViewChecked() {
    this.changeDetector.detectChanges()
  }
}
